export enum Constants {
    ADD_GROUP = 'ADD_GROUP',
    UPDATE_GROUP = 'UPDATE_GROUP',
    REMOVE_GROUP = 'REMOVE_GROUP',
    ADD_GROUP_MEMBER = 'ADD_GROUP_MEMBER',
    REMOVE_GROUP_MEMBER = 'REMOVE_GROUP_MEMBER',
    UPDATE_GROUP_MEMBER = 'UPDATE_GROUP_MEMBER'


}
